export default function SignatureFilledIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8047 4.19554L8.80468 0.195535C8.62001 0.0108685 8.34334 -0.0484648 8.09868 0.0428685L2.76534 2.04287C2.54068 2.12687 2.37734 2.32754 2.34134 2.56554L1.00801 11.2322C0.975345 11.4415 1.04534 11.6549 1.19534 11.8049C1.32068 11.9309 1.49068 12.0002 1.66668 12.0002C1.70068 12.0002 1.73468 11.9975 1.76801 11.9922L10.4347 10.6589C10.6727 10.6222 10.8727 10.4602 10.9573 10.2342L12.9573 4.90087C13.0493 4.6562 12.9893 4.3802 12.8047 4.19554ZM7.94268 6.94287C7.42201 7.46354 6.57801 7.46354 6.05734 6.94287C5.53668 6.4222 5.53668 5.5782 6.05734 5.05754C6.57801 4.53687 7.42201 4.53687 7.94268 5.05754C8.46334 5.5782 8.46334 6.4222 7.94268 6.94287Z"
        fill="currentColor"
      />
      <path
        d="M1 15H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
